import { PageLayout, PageSection } from '@orrekie/ui';

import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { enableWorkspaceSubstrateRoutes } from '../../lib/productCapabilities';

export default function WorkspaceSubstrateUnavailablePage() {
  return (
    <PageLayout>
      <PageSection
        title="Not yet available"
        subtitle="Projects and assessments"
        data-testid="workspace-substrate-unavailable"
      >
        <p className="text-sm text-[var(--ui-sidebar-muted-text)] max-w-xl">
          Projects and assessments are not yet available in production. This area will be
          enabled after the backend assessment services are deployed and verified.
        </p>
        <p className="mt-4 text-sm">
          <Link
            to="/u-value/calculator"
            className="font-medium text-[var(--ui-color-violet-600)] hover:underline"
            data-testid="workspace-unavailable-uvalue-link"
          >
            Open U-value calculator
          </Link>
        </p>
      </PageSection>
    </PageLayout>
  );
}

/** Blocks workspace/substrate/assessment pages when the capability is disabled (production default). */
export function WorkspaceSubstrateRouteGuard({ children }: { children: ReactNode }) {
  if (!enableWorkspaceSubstrateRoutes()) {
    return <WorkspaceSubstrateUnavailablePage />;
  }
  return children;
}
